import CircularProgress from '@mui/material/CircularProgress';
import type { FC } from 'react';

const CircleLoader: FC = () => <CircularProgress color="primary" size={60} />;

export default CircleLoader;
